module.exports = __webpack_public_path__ + "assets/d7ece53f4184b4bd777a5e79073d32e6.png";